export default __webpack_public_path__ + "static/media/ml.7c3b049c.png";